"use client";

import { StickyNote } from "lucide-react";

interface NoteBlockProps {
  body: string | null;
  createdAt: string;
  userName: string | null;
}

export function NoteBlock({ body, createdAt, userName }: NoteBlockProps) {
  return (
    <div className="flex justify-end">
      <div className="min-w-[85%] max-w-[85%] rounded-lg border border-gray-100 border-x-4 border-yellow-400 bg-white p-3">
        <div className="flex items-start gap-2">
          <div className="rounded-full bg-yellow-100 p-1.5 text-yellow-600">
            <StickyNote className="h-3.5 w-3.5" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <p className="text-xs font-medium text-gray-900">Internal Note</p>
              <span className="text-[10px] text-gray-400">
                {new Date(createdAt).toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" })}
              </span>
            </div>
            {userName && <p className="text-[10px] text-gray-500">by {userName}</p>}
            {body && <p className="mt-1 text-xs text-gray-700 break-words">{body}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
